export const LOCAL_STORAGE_ITEM_NAMES = {
  WALLET_TYPE: 'WALLET_TYPE',
  SETTINGS: 'settings',
  global: 'app_global',
  COMMON_TOKENS: 'common_tokens',
  CUSTOM_TOKENS: 'customTokens',
}
